export default __webpack_public_path__ + "static/media/0x8346ab8d5ea7a9db0209aed2d1806afa0e2c4c21.221762f5.png";